export default class Uploaders {
  constructor() {
    this.bindHandlers();
  }

  bindHandlers() {
    $(document).on('mf.uploadcomplete', (e, responseJSON) => {
      switch(e.uploaderName) {
        case 'horse-profile-image-modal': { this.onHorseProfileImageUploaded(responseJSON); break; }
        case 'horse-image-modal':         { break; }
        case 'horse-document-modal':      { this.onAnimalDocumentUploaded(responseJSON); break; }
      }
    });
  }

  onHorseProfileImageUploaded(responseJSON) {
    $('#horse_profile_image').prop('src', responseJSON.profile_image.url);
  }


  onAnimalDocumentUploaded(data) {
    window.location.reload();
  }
}
